import { Grid } from '@simplywallst/ui-core';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';
import { Props } from './types';
import { MobileLayout } from './components/MobileLayout';
import { DesktopLayout } from './components/DesktopLayout';

export const NarrativeFormContent = ({ ...props }: Props) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return (
    <Grid templateColumnsLg="2fr 1fr" templateColumns="1fr" gap="16px">
      {isMobileScreen ? (
        <MobileLayout {...props} />
      ) : (
        <DesktopLayout {...props} />
      )}
    </Grid>
  );
};
